import { Flex, token } from '@bynder/design-system';
import styled from 'styled-components';

export const StyledFlex = styled(Flex)`
    overflow-x: scroll;
    width: 100%;
    padding: ${token.spacing2};
`;
